<div class="notification-dropdown">
  <button
    type="button"
    (click)="toggleDropdown()"
    class="notification-icon"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-label]="'notification.title' | translate"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    @if (unreadCount() > 0) {
      <span class="notification-badge">{{ unreadCount() > 99 ? '99+' : unreadCount() }}</span>
    }
  </button>

  @if (isOpen()) {
    <div class="notification-dropdown__menu">
      <div class="notification-dropdown__header">
        <h3 class="notification-dropdown__title">{{ 'notification.title' | translate }}</h3>
        <div class="notification-dropdown__actions">
          @if (unreadCount() > 0) {
            <button
              type="button"
              (click)="markAllAsRead()"
              class="notification-dropdown__action"
            >
              {{ 'notification.markAllAsRead' | translate }}
            </button>
          }
          <button
            type="button"
            (click)="closeDropdown()"
            class="notification-dropdown__close"
            [attr.aria-label]="'Buttons.Close' | translate"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      <div class="notification-dropdown__content">
        @if (isLoadingNotifications() && notifications().length === 0) {
          <div class="notification-dropdown__loading">
            <div class="notification-dropdown__spinner"></div>
          </div>
        } @else if (notifications().length === 0 && !isLoadingNotifications()) {
          <div class="notification-dropdown__empty">
            <p>{{ 'notification.noNotifications' | translate }}</p>
          </div>
        } @else {
          <ul class="notification-dropdown__list">
            @for (notification of notifications(); track notification.id) {
              <li
                class="notification-dropdown__item"
                [class.notification-dropdown__item--unread]="!notification.isRead"
                (click)="handleNotificationClick(notification)"
              >
                <div class="notification-dropdown__item-content">
                  <h4 class="notification-dropdown__item-title">
                    {{ notification.titleAr || notification.title }}
                  </h4>
                  <p class="notification-dropdown__item-message">
                    {{ notification.messageAr || notification.message }}
                  </p>
                  <p class="notification-dropdown__item-date">
                    {{ notification.createdAtUtc | date: 'short' }}
                  </p>
                </div>
                @if (!notification.isRead) {
                  <div class="notification-dropdown__item-indicator"></div>
                }
              </li>
            }
          </ul>
          @if (hasNextPage() && !isLoadingMore()) {
            <button
              type="button"
              (click)="loadMoreNotifications()"
              class="notification-dropdown__load-more"
            >
              {{ 'notification.loadMore' | translate }}
            </button>
          }
          @if (isLoadingMore()) {
            <div class="notification-dropdown__loading-more">
              <div class="notification-dropdown__spinner"></div>
            </div>
          }
        }
      </div>
    </div>
  }
</div>

